import React, { useState } from "react";

// Wallabies Warm Care Component
const Departments = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  // Tab Data - Only One Department (Wallabies Warm Care)
  const departments = [
    {
      id: "tab1",
      icon: "icofont-heart-beat",
      title: "Wallabies Warm Care",
      subtitle: "Forced Air-Warming Systems & Blankets",
      details: [
        "Wallabies Warm Care is the leading producer and supplier of forced air-warming systems and forced air-warming blankets.",
        "We take pride in serving society with quality products.",
        "Our products are designed as per the requirements of the patients and we always take care of the complete comfort of the patient while designing a forced air-warming system.",
        "Our systems utilize the latest in warming technology, ensuring that patients remain at the ideal temperature during medical procedures.",
        "Wallabies Warm Care offers a variety of solutions to meet the needs of different medical environments, from operating rooms to post-operative recovery areas.",
        
      ],
      image: "/images/keyword/1.jpg", // Replace with an appropriate image if needed
    },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <section className="departments section" style={{ backgroundColor: "#f0f8ff", padding: "60px 0" }}>
      <div className="container">
        <div className="row text-center">
          <div className="col-12">
            <div className="section-title">
              <h2 className="font-weight-bold text-dark mb-4">Wallabies Warm Care - Our Product Offering</h2>
              <img
                src="img/section-img.png"
                alt="Section Image"
                className="img-fluid rounded shadow-lg mb-4"
                style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="department-tab tab-menu">
              {/* Tab Navigation */}
              <div className="list-group nav nav-tabs justify-content-center" id="list-tab" role="tablist">
                {departments.map((dept) => (
                  <a
                    key={dept.id}
                    className={`list-group-item nav-item text-center p-4 ${activeTab === dept.id ? "active" : ""}`}
                    data-bs-toggle="list"
                    href={`#${dept.id}`}
                    role="tab"
                    onClick={() => handleTabClick(dept.id)}
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#ffffff",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                      transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
                    onMouseLeave={(e) => e.target.style.backgroundColor = "#ffffff"}
                  >
                    <i className={`${dept.icon} mb-2`} style={{ fontSize: "2rem", color: "#1A76D1" }}></i>
                    <span className="d-block">{dept.title}</span>
                    <span className="d-block text-muted">{dept.subtitle}</span>
                  </a>
                ))}
              </div>

              {/* Tab Content */}
              <div className="tab-details mt-4">
                <div className="tab-content" id="nav-tabContent">
                  {departments.map((dept) => (
                    <div
                      key={dept.id}
                      className={`tab-pane fade ${activeTab === dept.id ? "show active" : ""}`}
                      id={dept.id}
                      role="tabpanel"
                    >
                      <div className="row align-items-stretch">
                        <div className="col-lg-6 mb-4 d-flex align-items-stretch">
                          <div className="department-left flex-grow-1">
                            <h3 className="text-dark mb-3">{dept.title}</h3>
                            <ul className="list-unstyled">
                              {dept.details.map((detail, index) => (
                                <li key={index} className="mb-2" style={{ fontSize: "1.1rem", color: "#333" }}>
                                  <i className="fa fa-check" style={{ color: "#1A76D1" }}></i> {detail}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-6 mb-4 d-flex align-items-stretch">
                          <div className="department-right flex-grow-1">
                            <img
                              src={dept.image}
                              alt={dept.title}
                              className="img-fluid rounded shadow-sm"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Departments;
